export default __webpack_public_path__ + "static/PJD_logo-7194fa0399cc644ef5c4c63fb66410ea.jpg";